import { Range } from '@/components'

import styles from './RangeSelector.module.scss'

export const RangeSelector = ({ control, name, label, max, value }) => {
  return (
    <div className={styles.rangeSelector}>
      <Range control={control} min="1" max={max} name={name} />

      <div className={styles.rangeSelector__quantity}>
        <span>{value || max / 2}</span>
        <hr className={styles.rangeSelector__divider} />
        <span>{label}</span>
      </div>
    </div>
  )
}
